<template>
  <WhiteIQOS
    :systemDependency="mode"
    required
    enabled
    :title="$t('auto_cancel_panel.title')"
    :subtitle="$t('auto_cancel_panel.comment')"
  >
    <BaseNumberInput
      @blur="save"
      class="w-100"
      fullWidth
      v-model.number="timeout"
      type="number"
      placeholder="15"
      :valid="!invalid"
      :unit="$t('units.mins')"
    />
  </WhiteIQOS>
</template>

<script>
export default {
  props: {
    mode: String,
  },
  data() {
    return {
      timeout: 15,
      invalid: false,
    };
  },
  methods: {
    save() {
      if (!this.timeout || this.timeout < 1 || this.timeout > 1440) {
        this.invalid = true;
        return;
      }

      this.invalid = false;
      this.$store.commit("setAutoCancelTimeout", {
        mode: this.mode,
        value: this.timeout,
      });
      this.$store.dispatch("saveCafe");
    },
  },
  mounted() {
    const cafe = this.$store.state.cafe;
    const container = this.mode == "inside" ? cafe : cafe[this.mode];

    this.timeout = container.auto_cancel_timeout || 15;
  },
};
</script>

<style></style>
